import React from 'react'
import Container from '../../../components/Admin/Container/Container'
import Add from '../../../components/Admin/AddCompany/Add'

export default function AddCompany() {
  return (
    <Container>
        <Add/>
    </Container>
  )
}
